import { useState } from "react";

const useForm = ({ fields = {}, validate }) => {
  const initialFormState = {
    fields: getFormattedFields(fields),
    errors: {},
    isSubmitted: false,
    isValid: false,
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState(initialFormState);
  const isSubmitDisabled = isSubmitting || (form.isSubmitted && !form.isValid);

  const onChange = (e) => {
    const { name, value, type, files } = e.target;

    const newState = {
      ...form,
      fields: {
        ...form.fields,
        ...{
          [name]: {
            ...form.fields[name],
            value: type === "file" ? files[0] : value,
            isTouched: true,
          },
        },
      },
    };

    validate(newState, setForm);
  };

  const isInvalidField = (key) => {
    const field = form.fields[key];
    const error = form.errors[key];

    return (field.isTouched && error) || (form.isSubmitted && error);
  };

  const resetForm = () => setForm(initialFormState);

  const getParams = () => {
    const params = {};

    Object.entries(form.fields).forEach(([key, field]) => {
      params[key] = field.value ?? null;
    });

    return params;
  };

  return {
    form,
    setForm,
    resetForm,
    getParams,
    onChange,
    isInvalidField,
    isSubmitDisabled,
    isSubmitting,
    setIsSubmitting,
  };
};

const getFormattedFields = (fields) => {
  const formattedFields = {};

  Object.entries(fields).forEach(([key, field]) => {
    formattedFields[key] = { ...{ value: "", isTouched: false }, ...field };
  });

  return formattedFields;
};

export default useForm;
